/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty-pattern */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";
import { CenterBox, ColDiv, RowDiv } from "../../components/misc/misc.styled";
import { Lbl } from "../../components/labels";
import { AppCSS, Spacer, TapButton, TxtInput } from "../../components";
import { useState } from "react";
import { LoginContainer } from "./login.styled";
import { toast } from "react-toastify";
import { useMutation } from "@apollo/client";
import logo from "../../images/companylogo.png";
import { SET_NEW_PASSWORD_MUTATION } from "../../apolloClient/operation/mutations";

interface NewPasswordInput {
  input: {
    email: string;
    password: string;
    code: string;
  };
}

const commonCenterBoxStyle = {
  maxWidth: "420px",
  padding: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  backgroundColor: "#fff",
  overflow: "auto",
};

const commonTxtInputProps = {
  width: 380,
  height: 40,
  borderColor: "#ccc",
  borderRadius: 4,
  paddingLeft: 10,
  textColor: "#000",
};

export const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();

  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const code = queryParams.get("code");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [setNewPasswordMutation, { data, error }] = useMutation<
    { setAdminPassword: boolean },
    NewPasswordInput
  >(SET_NEW_PASSWORD_MUTATION);

  const onTapSetPass = async () => {
    if (newPassword !== confirmPassword) {
      toast("Confirm password does not match!", {
        type: "error",
      });
      return;
    }
    if (!email || !code) {
      toast("Reset link is not valid!");
      return;
    }

    try {
      const response = await setNewPasswordMutation({
        variables: {
          input: {
            email: email,
            password: newPassword,
            code: code,
          },
        },
      });
      if (response.data?.setAdminPassword) {
        toast("Password changed successfully!", {
          type: "success",
        });
        navigate("/");
      } else {
        toast("Error resetting the password!", {
          type: "error",
        });
      }
    } catch (error) {
      toast("Error resetting the password!", {
        type: "error",
      });
    }
  };

  const forgotPasswordView = () => {
    return (
      <CenterBox style={commonCenterBoxStyle}>
        <img src={logo} alt="Logo" style={{ width: "180px" }} />
        <RowDiv>
          <Lbl title="Set New Password" size={25} bold={500} />
        </RowDiv>

        <Spacer size={2} direction="col" />

        <ColDiv>
          <TxtInput
            type="password"
            placeholder="New Password"
            onChange={setNewPassword}
            {...commonTxtInputProps}
          />
          <Spacer size={1} direction="col" />
          <TxtInput
            type="password"
            placeholder="Confirm Password"
            onChange={setConfirmPassword}
            onPressEnter={onTapSetPass}
            {...commonTxtInputProps}
          />
        </ColDiv>
        <Spacer size={2} direction="col" />
        <RowDiv
          style={{
            justifyContent: "space-between",
          }}
        >
          <TapButton
            onTap={onTapSetPass}
            title="Submit"
            bgColor={AppCSS.GLAS_BLUE}
            height={40}
          />
        </RowDiv>
        <Spacer size={2} direction="col" />
      </CenterBox>
    );
  };

  return <LoginContainer>{forgotPasswordView()}</LoginContainer>;
};

export default ForgotPassword;
